// Base font and flex styles
const baseFont = { fontFamily: 'Overpass' };
const basePrimaryText = { color: 'text.primary', ...baseFont };
const flexAlignCenter = { alignItems: 'center', display: 'flex' };

// Empty state styles
export const emptyStateStyles = {
  backgroundColor: 'graphic.lighter',
  boxSizing: 'border-box',
  color: 'text.primary',
  minHeight: 88,
  minWidth: 0,
  overflow: 'hidden',
  p: 3,
  position: 'relative',
  width: 1,
};
export const emptyStateContentSx = {
  ...flexAlignCenter,
  gap: 2,
  minWidth: 0,
  width: 1,
};
export const emptyStateIconSx = {
  color: 'action.active',
  height: '32px',
  width: '32px',
};
export const emptyStateMessageSx = {
  ...baseFont,
  flex: 1,
  minWidth: 0,
  overflowWrap: 'anywhere',
};
export const hiddenPlaceholderSx = {
  height: 0,
  left: 0,
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
};

// Drawer section and field styles
export const futureDrawerSectionTitleSx = {
  ...basePrimaryText,
  fontWeight: 700,
  py: 3,
};
export const futureDrawerFieldLabelSx = {
  ...basePrimaryText,
  pb: 0.5,
};
export const futureDrawerFieldValueSx = {
  color: 'primary.dark',
};
export const futureDrawerSecondaryValueSx = futureDrawerFieldValueSx;

// Drawer layout
export const futureDrawerLayoutSx = {
  '& > :first-of-type': {
    '& .MuiIconButton-root': { mr: 0 },
    borderColor: 'surface.swimlane',
    boxShadow: 0,
    color: 'text.primary',
    height: 'auto',
    mb: 3,
    minHeight: 64,
    pl: 3,
    pr: 1.5,
    py: 2,
  },
};

// Sequence item styles
export const futureSequenceItemSx = {
  borderColor: 'divider',
  py: 1,
};
export const futureSequenceTextSx = basePrimaryText;
export const futureSequenceNameSx = {
  ...basePrimaryText,
  flex: 1,
};
export const futureSequenceChipSx = {
  backgroundColor: '_next.secondary.main',
  color: '_next.secondary.contrastText',
  ...baseFont,
  px: 0.5,
  py: 0.5,
};

// Available authorization styles
export const availableAuthorizationItemSx = {
  ...flexAlignCenter,
  justifyContent: 'space-between',
  py: 1,
};
export const availableAuthorizationContentSx = flexAlignCenter;
export const availableAuthorizationChipSx = active => ({
  backgroundColor: active ? 'secondary.main' : 'error.main',
  color: active ? 'secondary.contrastText' : 'error.contrastText',
  ...baseFont,
  height: '24px',
  pt: '2px',
});
export const availableAuthorizationNameSx = {
  ...basePrimaryText,
  pl: 2,
  whiteSpace: 'nowrap',
};

// Button and product location info styles
export const futureDrawerButtonSx = baseFont;
export const productLocationInfoContainerSx = { pl: 3, pr: 3 };
export const productLocationInfoRowSx = innerSpacing => ({
  ...flexAlignCenter,
  justifyContent: 'space-between',
  mt: innerSpacing,
});

// Dialog styles
export const unsavedDialogPaperSx = {
  '& .MuiButton-root': baseFont,
  '& .MuiDialog-paper': { height: 180, width: 330 },
  '& .MuiDialogContent-root': baseFont,
  '& .MuiDialogTitle-root': baseFont,
};
export const unsavedDialogActionsSx = { pb: 2, px: 2 };
